import {
  GridColumn as Column,
  GridColumnProps,
  Grid,
  GridPageChangeEvent,
} from "@progress/kendo-react-grid";
import "@progress/kendo-theme-default/dist/all.css";
import { CompositeFilterDescriptor } from "@progress/kendo-data-query";
import { forwardRef, useEffect, useState } from "react";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import styled from "styled-components";

interface Props {
  dataItemKey: string;
  columns: GridColumnProps[];
  data: any[];
  showLoader?: boolean;
  filter?: CompositeFilterDescriptor;
}

const StyledGrid = styled(Grid)`
  .k-column-title {
    min-width: 0;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 1;
    overflow: hidden;
    font-weight: bold; /* Make the font bold */
    font-family: "Roboto";
  }
  ,
  th {
    border-inline-start-width: 0px !important;
  }
  th > .k-cell-inner > .k-link {
    border-right: 2px solid var(--kendo-color-border);
    justify-content: center;
  }
  ,
  th > .k-cell-inner,
  .k-grid-header-wrap {
    background-color: white;
    height: 55px;
  }
  ,
  .k-table-row,
  .k-table-alt-row,
  .k-grid-table-wrap {
    background-color: #f3f4f6 !important;
  }
  ,
  .k-table-td {
    border-bottom: 1px solid var(--kendo-color-border);
    border-left: none;
    border-right: none;
    font-family: "Roboto";
    text-align: center;
  }
  .k-grid tr {
    background-color: #ffffff; /* White background for regular rows */
  }

  .k-grid tr.k-alt {
    background-color: #ffffff; /* Light grey background for alternate rows */
  }

  k-grid .k-table-row.k-table-alt-row {
    background-color: #f9f9f9;
  }
`;

export const DataGrid = forwardRef<ExcelExport, Props>(
  ({ dataItemKey, columns, data, showLoader, filter }, ref) => {
    const [page, setPage] = useState({ skip: 0, take: 20 });
    const handlePageChange = (event: GridPageChangeEvent) => {
      setPage(event.page);
    };

    useEffect(() => {
      setPage((prev) => ({ ...prev, skip: 0 }));
    }, [filter]);

    return (
      <>
        <ExcelExport ref={ref}>
          <StyledGrid
            data={data}
            dataItemKey={dataItemKey}
            autoProcessData={true}
            sortable={false}
            showLoader={showLoader}
            filter={filter}
            scrollable="scrollable"
            pageable={{ buttonCount: 5, pageSizes: [10, 20, 30], info: true }}
            skip={page.skip}
            take={page.take}
            onPageChange={handlePageChange}
          >
            {columns.map((columnProps) => (
              <Column
                key={columnProps.title}
                {...columnProps}
                headerClassName={
                  columnProps.sortable === false ? "" : "sortable-column"
                }
              />
            ))}
          </StyledGrid>
        </ExcelExport>
      </>
    );
  }
);
